import { SVGIconType } from './svgIcon';

export enum SelectImageMode {
  Camera = 'Camera',
  UploadImage = 'UploadImage',
}

export type SelectImageModeDetailsType = {
  icon: SVGIconType;
  displayName: string;
};

export const SelectImageDetails: Record<
  SelectImageMode,
  SelectImageModeDetailsType
> = {
  [SelectImageMode.Camera]: {
    icon: SVGIconType.Camera,
    displayName: 'Camera',
  },
  [SelectImageMode.UploadImage]: {
    icon: SVGIconType.Picture,
    displayName: 'Upload Image',
  },
};
